/* eslint-disable max-len */
import React from 'react';

export const NetworkErrorSVG = () => (
  <svg
    width="240"
    height="250"
    viewBox="0 0 240 250"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Network error illustration"
  >
    <mask
      id="mask0_1596_6842"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="0"
      y="150"
      width="154"
      height="68"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.119873 150.567H153.303V217.31H0.119873V150.567Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1596_6842)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-85.9407 217.31C-85.9407 178.103 -81.7326 159.95 -79.7088 153.488C-79.1659 151.753 -77.547 150.567 -75.7086 150.567H143.071C144.901 150.567 146.523 151.74 147.065 153.466C149.085 159.909 153.303 178.059 153.303 217.31H-85.9407Z"
        fill="#47C2BB"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M132.636 155.609H115.4C110.433 155.609 105.938 158.69 103.978 163.447C100.421 172.086 98.5684 181.416 98.5684 190.878V218.03H149.468V190.878C149.468 181.416 147.615 172.086 144.057 163.447C142.098 158.69 137.603 155.609 132.636 155.609Z"
      fill="#0E9D97"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M73.1308 155.609H55.8944C50.9271 155.609 46.4328 158.69 44.4731 163.447C40.9153 172.086 39.063 181.416 39.063 190.878V218.03H89.9622V190.878C89.9622 181.416 88.1099 172.086 84.5519 163.447C82.5924 158.69 78.0978 155.609 73.1308 155.609Z"
      fill="#0E9D97"
    />
    <mask
      id="mask1_1596_6842"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="0"
      y="155"
      width="28"
      height="64"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.119873 155.609H27.3403V218.03H0.119873V155.609Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_1596_6842)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.509 155.609H-6.72739C-11.6947 155.609 -16.189 158.69 -18.1488 163.447C-21.7067 172.086 -23.5588 181.416 -23.5588 190.878V218.03H27.3402V190.878C27.3402 181.416 25.4881 172.086 21.9301 163.447C19.9706 158.69 15.476 155.609 10.509 155.609Z"
        fill="#0E9D97"
      />
    </g>
    <mask
      id="mask2_1596_6842"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="0"
      y="213"
      width="155"
      height="7"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.119873 213.708H154.622V219.23H0.119873V213.708Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_1596_6842)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.416 216.349C107.636 216.349 94.2112 213.708 94.2112 213.708C94.2112 213.708 80.7867 216.349 64.0061 216.349C47.2255 216.349 33.801 213.708 33.801 213.708C33.801 213.708 20.3765 216.349 3.59586 216.349C-13.1848 216.349 -26.6093 213.708 -26.6093 213.708C-26.6093 213.708 -40.0338 216.349 -56.8144 216.349C-67.176 216.349 -76.2579 215.491 -81.69 214.65C-84.4931 214.217 -87.0195 216.39 -87.0195 219.23H154.622C154.622 216.39 152.095 214.217 149.292 214.65C143.86 215.491 134.778 216.349 124.416 216.349Z"
        fill="#47C2BB"
      />
    </g>
    <mask
      id="mask3_1596_6842"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="48"
      y="58"
      width="191"
      height="82"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.0647 58.1369H239V139.764H48.0647V58.1369Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_1596_6842)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.5913 139.764H238.07C242.227 139.764 245.597 136.389 245.597 132.226V65.6747C245.597 61.5117 242.227 58.1369 238.07 58.1369H55.5913C51.4345 58.1369 48.0647 61.5117 48.0647 65.6747V132.226C48.0647 136.389 51.4345 139.764 55.5913 139.764Z"
        fill="#B1E1F4"
      />
    </g>
    <mask
      id="mask4_1596_6842"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="48"
      y="58"
      width="191"
      height="82"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.591 58.1369C51.4342 58.1369 48.0645 61.5115 48.0645 65.6747V132.226C48.0645 136.389 51.4342 139.764 55.591 139.764H238.07C238.385 139.764 238.695 139.744 239 139.707V58.1941C238.695 58.1564 238.385 58.1369 238.07 58.1369H55.591Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask4_1596_6842)">
      <path
        opacity="0.184229"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M399.787 97.4484L388.572 87.6815L377.357 97.4484V100.491H360.858V92.8619L354.926 90.7492V86.6292L348.994 84.5165V80.3965L344.275 78.716V49.2539H326.108V89.7263H319.805V63.3636L304.234 68.933V84.3422H291.999V99.0087H281.432L281.752 113.487H275.542V109.942L269.61 107.829V103.709L263.678 101.597V97.4765L252.926 93.6472V90.4662H241.989V111.445H235.872V76.7279H213.256V106.432H205.47V89.9092L202.318 86.1961L199.167 89.9092V106.432H195.459V94.1793L192.308 90.4662L189.156 94.1793V113.487H183.41V99.1919H168.58V112.395H156.174C151.495 104.356 140.487 98.7103 127.653 98.7103C114.818 98.7103 103.81 104.356 99.1313 112.395H84.5024V127.04H77.5504V106.633H66.0437V127.04H61.0095V83.3452H37.9961V161.611H41.5919H61.0095H66.0437H77.5504H84.5024H150.666H170.563V159.529H399.787V97.4484Z"
        fill="#0383A4"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M105.032 44.9722H112.381C112.165 38.9402 109.831 26.3788 108.532 19.9831C107.35 26.3855 105.227 38.9395 105.032 44.9722ZM114.075 47.253H103.339V46.4127C103.339 38.4987 107.494 16.0976 107.67 15.2024L109.313 15.187C109.508 16.0827 114.075 38.4908 114.075 46.4127V47.253Z"
      fill="#3B3F41"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.0318 44.9722H37.3805C37.1655 38.9402 34.8308 26.3788 33.5322 19.9831C32.3497 26.3855 30.2272 38.9395 30.0318 44.9722ZM39.0746 47.253H28.3391V46.4127C28.3391 38.4987 32.4935 16.0976 32.6702 15.2024L34.313 15.187C34.5077 16.0827 39.0746 38.4908 39.0746 46.4127V47.253Z"
      fill="#3B3F41"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M105.076 44.6692C104.122 44.6692 103.34 45.441 103.339 46.397V46.4126V47.2529H114.075V46.4126V46.396C114.074 45.4403 113.292 44.6692 112.338 44.6692H105.076Z"
      fill="#9AA3AD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.0761 44.6692C29.1216 44.6692 28.3398 45.441 28.3391 46.397V46.4126V47.2529H39.0746V46.4126V46.396C39.0737 45.4403 38.2917 44.6692 37.3376 44.6692H30.0761Z"
      fill="#9AA3AD"
    />
    <mask
      id="mask5_1596_6842"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="210"
      y="151"
      width="29"
      height="70"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M210.357 151.567H239V220.23H210.357V151.567Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask5_1596_6842)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M235.26 214.708C228.935 214.708 223.427 210.381 221.929 204.227C217.642 186.612 215.52 162.69 214.884 154.476C214.757 152.833 213.388 151.567 211.744 151.567H210.357V220.23H261.658C261.658 217.18 259.19 214.708 256.144 214.708H235.26Z"
        fill="#47C2BB"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M185.455 214.708C191.779 214.708 197.287 210.381 198.785 204.227C203.072 186.612 205.194 162.69 205.831 154.476C205.958 152.833 207.326 151.567 208.971 151.567H210.357V220.23H159.056C159.056 217.18 161.525 214.708 164.57 214.708H185.455Z"
      fill="#47C2BB"
    />
    <mask
      id="mask6_1596_6842"
      style={{ maskType: 'luminance' } as React.CSSProperties}
      maskUnits="userSpaceOnUse"
      x="0"
      y="8"
      width="239"
      height="242"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.119873 8H165.5H239V250H0.119873V8Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask6_1596_6842)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M212.345 57.0332C215.507 55.5882 222.683 62.8402 213.524 68.4184C213.044 68.8629 212.507 69.2734 211.913 69.6337L211.907 69.6237L210.696 70.6692C209.627 71.5846 208.549 72.4878 207.465 73.3845C205.294 75.1758 203.088 76.932 200.841 78.6568C198.594 80.3798 198.283 80.5097 195.928 82.1519C192.382 84.5624 188.561 85.8419 185.005 85.7789C182.844 85.7409 180.781 85.2082 178.938 84.131C178.563 83.9118 178.197 83.6625 177.843 83.3935C176.813 82.7916 173.022 79.6003 173.022 79.6003C173.022 79.6003 181.421 75.2459 183.232 74.2605L186.449 73.2422C186.424 73.2557 186.401 73.2714 186.376 73.2853C189.825 71.8501 193.79 70.6535 197.644 67.9278C202.421 64.5498 206.111 60.0617 206.111 60.0617C206.111 60.0617 207.113 57.4823 209.877 56.7019"
        fill="#B26E4B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M381.973 10.4008V14.9623H212.069V10.4008C212.069 9.07484 210.996 8 209.672 8C208.348 8 207.275 9.07484 207.275 10.4008V14.9623H-65.3054V10.4008C-65.3054 9.07484 -66.3787 8 -67.7027 8C-69.0264 8 -70.0999 9.07484 -70.0999 10.4008V14.9623H-241.697V10.4008C-241.697 9.07484 -242.77 8 -244.094 8C-245.418 8 -246.491 9.07484 -246.491 10.4008V14.9623H-416.395V10.4008C-416.395 9.07484 -417.468 8 -418.792 8C-420.116 8 -421.189 9.07484 -421.189 10.4008V250H-416.395V19.7639H-246.491V250H-241.697V19.7639H-70.0999V250H-65.3054V19.7639H207.275V250H212.069V19.7639H381.973V250H386.768V10.4008C386.768 9.07484 385.695 8 384.371 8C383.047 8 381.973 9.07484 381.973 10.4008Z"
        fill="#697079"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M214.12 57C211.358 57 209.12 59.2386 209.12 62C209.12 64.7614 211.358 67 214.12 67"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M150.76 245.785L162.456 250H136.159L139.999 190.232L137.767 142.726C137.477 136.576 142.337 131.417 148.468 131.364L168.578 131.192C174.584 131.14 179.479 136.017 179.475 142.048L179.448 190.141L179.447 190.647L179.425 190.85L174.619 234.153C174.623 235.732 174.96 237.257 175.579 238.641C176.609 240.948 174.306 244.211 176.643 245.317L189.854 250H163.556L167.397 190.232L165.806 156.388H152.07L152.05 190.141L152.05 190.647L152.027 190.85L147.221 234.153C147.225 235.732 147.563 237.257 148.181 238.641C149.212 240.948 148.422 244.679 150.76 245.785Z"
      fill="#0383A4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M151.224 72.4373L151.907 60.0936H161.809L162.492 74.7593C171.199 78.1243 172.365 81.6309 172.365 88.4273L139.952 86.0427C139.952 79.2462 140.834 73.6164 151.224 72.4373Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M163.915 46.5461C169.387 48.0269 170.862 52.0809 170.378 58.3207C170.363 59.1131 170.245 63.1284 169.66 63.7892C169.076 64.4488 167.878 64.5658 166.994 64.3574C164.835 69.3233 161.989 71.4893 158.67 70.5911C154.148 69.3675 151.098 63.7088 153.348 55.3272C155.157 48.5843 158.043 44.9569 163.915 46.5461Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M161.928 44.2433C162.379 44.267 169.531 45.9108 169.607 50.9543C156.873 45.0594 158.555 59.3941 159.043 62.4115C170.022 61.5164 168.646 65.8788 164.648 72.299C164.295 72.8654 163.579 73.086 162.936 72.9161C160.092 72.1644 151.461 70.0984 151.133 60.3698C150.893 53.2589 152.503 50.4573 153.612 47.0657C154.323 44.891 159.651 44.1239 161.928 44.2433Z"
      fill="#3B3F41"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M163.838 54.2535L168.193 55.9269L167.36 58.1141L163.004 56.4405L163.838 54.2535ZM171.46 57.182L173.638 58.0187L172.805 60.2057L170.627 59.3691L171.46 57.182ZM163.309 53.6744L162.226 56.5177C162.157 56.6988 162.247 56.9019 162.428 56.9711L167.437 58.8955C167.617 58.965 167.82 58.8743 167.889 58.693L168.43 57.2714L170.39 58.0244V58.0246L170.378 58.3205C170.373 58.5916 170.356 59.239 170.312 60.0002L172.882 60.9874C173.062 61.0566 173.264 60.9659 173.333 60.7848L174.417 57.9417C174.486 57.7604 174.395 57.5573 174.215 57.4881L171.384 56.4002C171.203 56.331 171.001 56.4217 170.932 56.6028L170.64 57.3684L168.68 56.6152L168.972 55.8499C169.041 55.6687 168.951 55.4657 168.77 55.3962L163.761 53.4718C163.58 53.4026 163.378 53.4933 163.309 53.6744Z"
      fill="#774331"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M143.985 73.9128C146.358 73.2125 148.846 72.7073 151.224 72.4374L162.588 83.2758L162.492 74.0567C162.85 74.1563 163.204 74.2599 163.551 74.3669C165.367 74.8228 167.382 75.5316 169.415 76.3586C177.841 79.7872 179.593 85.6806 179.593 94.8105V142.987H137.62L133.458 89.2384C132.919 82.2735 137.31 75.8823 143.985 73.9128Z"
      fill="#F15961"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M179.129 250H163.556L163.97 244.146L175.635 238.76C176.673 241.013 178.459 242.879 180.755 243.966L181.502 244.348C180.079 245.677 179.16 247.711 179.129 250Z"
      fill="#9AA3AD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M189.854 249.372V250H179.13C179.16 247.711 180.08 245.677 181.502 244.348L189.166 248.27C189.585 248.468 189.854 248.898 189.854 249.372Z"
      fill="#78868E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M169.333 245.317C167.954 245.317 166.832 244.222 166.774 242.851L171.083 240.861C171.584 241.332 171.898 241.999 171.898 242.741C171.898 244.164 170.75 245.317 169.333 245.317Z"
      fill="#F4F8FA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M151.847 250H136.159L136.454 244.38L148.237 238.76C149.276 241.013 151.061 242.879 153.358 243.966L154.178 244.385C152.779 245.715 151.877 247.733 151.847 250Z"
      fill="#9AA3AD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.456 249.372V250H151.847C151.877 247.733 152.779 245.715 154.179 244.386L161.769 248.27C162.188 248.468 162.456 248.898 162.456 249.372Z"
      fill="#78868E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M142.05 245.317C140.697 245.317 139.591 244.264 139.495 242.93L143.811 240.871C144.305 241.341 144.615 242.004 144.615 242.741C144.615 244.164 143.467 245.317 142.05 245.317Z"
      fill="#F4F8FA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M151.74 95.2181L153.776 97.5598H179.611V95.2181H151.74Z"
      fill="#FFCC66"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M160.658 51.2771C160.658 51.2771 151.862 51.6585 151.548 53.7943C151.324 55.318 152.283 49.1474 152.851 45.4851C153.102 43.8656 154.54 42.7556 156.171 42.8145C167.065 43.2087 180.055 51.709 175.237 53.8696C166.961 50.6901 160.658 51.2771 160.658 51.2771Z"
      fill="#103540"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M170.427 55.0302C170.386 54.3523 170.31 53.7083 170.192 53.1024C166.879 51.8436 163.554 51.371 160.658 51.2772L168.99 50.7212C172.898 50.6049 177.789 53.2408 178.594 55.3965C178.693 55.6613 178.478 55.9389 178.197 55.924C175.621 55.7865 170.535 55.0716 170.535 55.0716L170.427 55.0302Z"
      fill="#1B566B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M155.608 99.6672L159.883 104.585H179.611V99.6672H155.608Z"
      fill="#F6915A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M194.951 108.859L187.124 107.586C186.436 107.474 186.067 106.84 186.3 106.17L191.827 90.2253C192.06 89.5545 192.806 89.1016 193.493 89.2132L201.32 90.4856C202.008 90.5972 202.376 91.2315 202.144 91.902L196.616 107.846C196.384 108.517 195.638 108.97 194.951 108.859Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M199.707 94.1792C199.243 94.1039 198.995 93.6758 199.152 93.2234L199.557 92.0532C199.714 91.6008 200.217 91.2951 200.681 91.3704C201.145 91.446 201.393 91.8738 201.237 92.3262L200.831 93.4964C200.674 93.9488 200.171 94.2545 199.707 94.1792Z"
      fill="#6A707A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M148.925 111.82C148.658 111.476 148.411 111.107 148.182 110.725C146.661 108.767 153.914 102.602 157.851 102.127L159.876 104.456C159.847 104.459 159.82 104.465 159.792 104.469C163.513 104.412 167.623 104.77 172.193 103.661C177.856 102.285 182.919 99.471 182.919 99.471C182.919 99.471 184.794 97.4378 187.64 97.7374C188.715 97.8598 189.501 98.3222 189.803 98.9632C193.262 98.7904 197.246 108.221 186.719 110.02C186.111 110.256 185.462 110.439 184.781 110.554L184.779 110.543L183.273 111.068C181.947 111.524 180.618 111.966 179.285 112.399C176.618 113.263 173.93 114.081 171.217 114.855C168.504 115.626 168.168 115.632 165.385 116.288C161.216 117.218 157.209 116.992 153.939 115.611C153.939 115.612 153.939 115.61 153.939 115.611C151.952 114.773 150.237 113.509 148.925 111.82Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M187.602 72.0624L162.6 74.0124L176.921 93.5124L192.456 84.2499L187.602 72.0624Z"
      fill="#F15961"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M154.133 30.6744C154.773 29.5505 155.696 28.5945 156.8 27.853L156.246 22.7674C153.876 23.7491 151.844 25.2974 150.4 27.2514L154.133 30.6744Z"
      fill="#D14C50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M173.6 27.2514C172.153 25.2974 170.127 23.7491 167.757 22.7674L167.2 27.853C168.306 28.5945 169.229 29.5528 169.87 30.6744L173.6 27.2514Z"
      fill="#D14C50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M139.526 17.2326C143.32 13.246 148.497 10.3293 154.4 8.99464L153.899 4.58139C146.811 6.03424 140.584 9.44537 136 14.1387L139.526 17.2326Z"
      fill="#D14C50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M169.6 8.99683C175.505 10.3293 180.681 13.246 184.474 17.2326L188 14.1387C183.417 9.44756 177.191 6.03424 170.104 4.58139L169.6 8.99683Z"
      fill="#D14C50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M158.4 33.4419C158.4 35.406 160.013 37 162 37C163.987 37 165.6 35.406 165.6 33.4419C165.6 33.4205 165.593 33.4015 165.593 33.3778C165.557 31.4446 163.966 29.8837 162 29.8837C160.034 29.8837 158.443 31.4446 158.407 33.3778C158.405 33.4015 158.4 33.4205 158.4 33.4419Z"
      fill="#D14C50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M146.665 23.5581C148.812 20.9336 151.774 18.922 155.2 17.8167L154.707 13.2791C150.124 14.5209 146.116 17.0112 143.2 20.363L146.665 23.5581Z"
      fill="#D14C50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M180.8 20.363C177.882 17.0112 173.877 14.5209 169.292 13.2791L168.8 17.819C172.228 18.9243 175.187 20.9336 177.336 23.5581L180.8 20.363Z"
      fill="#D14C50"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M159.8 26.7209C159.8 26.7209 160.9 26.2603 162 26.2603C163.1 26.2603 164.2 26.7209 164.2 26.7209L166.4 3.4606C166.4 3.4606 164.21 3 162.007 3C159.803 3 157.6 3.4606 157.6 3.4606L159.8 26.7209Z"
      fill="#D14C50"
    />
  </svg>
);
